import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { useMusicPlayer } from "@/context/MusicPlayerContext";
import { useI18n } from "@/context/I18n";
import TrackRow from "@/components/music/TrackRow";
import { Loader2, Play, Music2 } from "lucide-react";

export default function GenreDetail() {
  const { name } = useParams();
  const decoded = decodeURIComponent(name);
  const [data, setData] = useState(null);
  const { playQueue } = useMusicPlayer();
  const { t } = useI18n();

  useEffect(() => {
    api.get(`/music/genres/${encodeURIComponent(decoded)}`).then((r) => setData(r.data)).catch(() => setData(false));
  }, [decoded]);

  if (data === null) return <div className="p-10 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-zinc-500" /></div>;
  if (data === false) return <div className="p-10 text-zinc-400">...</div>;

  return (
    <div data-testid="genre-detail">
      <div className="p-4 md:p-8 pb-6 bg-gradient-to-b from-[#FF2A4D]/25 to-transparent flex items-end gap-6">
        <div className="w-40 h-40 rounded-lg bg-gradient-to-br from-[#FF2A4D] to-purple-700 flex items-center justify-center shadow-2xl shrink-0">
          <Music2 className="w-16 h-16 text-white" />
        </div>
        <div>
          <p className="text-xs uppercase tracking-wider font-bold">{t("genre")}</p>
          <h1 className="font-heading text-4xl md:text-5xl font-bold tracking-tight mt-2">{decoded}</h1>
          <p className="text-zinc-300 mt-3 text-sm">{data.tracks.length} {t("tracks")}</p>
        </div>
      </div>
      <div className="px-8 py-4">
        <button data-testid="genre-play-all" onClick={() => data.tracks.length && playQueue(data.tracks, 0)} className="w-14 h-14 rounded-full bg-[#FF2A4D] hover:bg-[#E61C3D] hover:scale-105 flex items-center justify-center transition-all shadow-[0_0_20px_rgba(255,69,0,0.4)]">
          <Play className="w-6 h-6 text-white ml-1" fill="white" />
        </button>
      </div>
      <div className="px-5 pb-6">
        {data.tracks.map((tr, i) => <TrackRow key={tr.id} track={tr} index={i} tracks={data.tracks} />)}
      </div>
    </div>
  );
}
